var render = function render(){
  var _vm$suggestedScanLine;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('product-scanned-info', {
    staticClass: "mr-1 d-inline-block",
    attrs: {
      "dispatch-request-line": _vm.suggestedScanLine
    }
  }), _c('div', {
    staticClass: "mt-2"
  }, [_c('small', [_c('b-button', {
    staticClass: "text-info p-0 m-0",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isModalOpen = true;
      }
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.suggestedScanLine.product_identifier))])]), _c('span', {
    staticClass: "d-inline-block text-black-50 mx-2"
  }, [_vm._v(" •")]), !_vm.hasDiscount ? _c('i', [_vm._v(_vm._s(_vm.originalUnitPrice) + " p/s")]) : _c('i', [_c('s', [_vm._v(_vm._s(_vm.originalUnitPrice))]), _vm._v(" " + _vm._s(_vm.discountUnitPrice) + " p/s ")]), _c('span', {
    staticClass: "d-inline-block text-black-50 mx-2"
  }, [_vm._v(" •")]), _c('i', [_vm._v("aantal: " + _vm._s(_vm.suggestedScanLine.quantity_pending))])], 1)]), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title-html": `<h3 class='mb-0'>${_vm.suggestedScanLine.product_identifier}</h3>`
    },
    model: {
      value: _vm.isModalOpen,
      callback: function ($$v) {
        _vm.isModalOpen = $$v;
      },
      expression: "isModalOpen"
    }
  }, [_vm.isLoadingProductInfo ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('h3', [_vm._v(_vm._s((_vm$suggestedScanLine = _vm.suggestedScanLine.sales_order_line) === null || _vm$suggestedScanLine === void 0 ? void 0 : _vm$suggestedScanLine.product_name))]), _c('img', {
    staticClass: "d-block my-4",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.getProductAttributeValue('image_url'),
      "alt": ""
    }
  }), _c('p', {
    staticClass: "font-size-lg"
  }, [!_vm.hasDiscount ? _c('span', [_vm._v(" " + _vm._s(_vm.originalUnitPrice) + " ")]) : _c('span', [_vm._v(" Van "), _c('s', [_vm._v(_vm._s(_vm.originalUnitPrice))]), _vm._v(" voor " + _vm._s(_vm.discountUnitPrice) + " ")])]), _c('b-row', {
    staticClass: "font-size-lg mt-4"
  }, _vm._l(_vm.suggestedScanLine.ean_codes, function (eanCode, index) {
    return _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm._v(" " + _vm._s(eanCode) + " ")]);
  }), 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }